/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { useContext } from 'react';
import { useApolloInjection } from '@zapier/checkout/src/contexts/ApolloInjection';
import { Currency, CurrencyContext, Price } from '@zapier/currency';

import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableTd,
  TableTh,
} from '@zapier/design-system';

import { PlanTier } from '@zapier/checkout/src/types';

import { useCurrentPlanTiers } from './hooks/useCurrentPlanTiers';

type MeteredTiersTableProps = {
  /**
   * If not provided, component will retrieve tiers from the user's current plan.
   **/
  tiers?: PlanTier[];
};

const formatTier = (numTasks: number, tierIndex: number) =>
  numTasks === -1
    ? 'Any Additional'
    : `${tierIndex === 0 ? 'First' : 'Next'} ${numTasks.toLocaleString(
        'en-US'
      )}`;

const formatPrice = (price: number, currency: Currency) =>
  price === 0 ? (
    'Included'
  ) : (
    <Price currency={currency} maxDecimals={4}>
      {price}
    </Price>
  );

const cell = css`
  background-color: transparent !important;
  font-size: 14px;
  padding: 0.5em 1em !important;
`;

const td = css`
  color: #9e96a2;
`;

const formatTiers = (data: PlanTier[] = [], currency: Currency) => {
  return data.map((tier, i) => (
    <TableRow key={i}>
      {/* @ts-ignore: Type 'SerializedStyles' is not assignable to type 'string'. */}
      <TableTd className={[cell, td]}>{formatTier(tier.numTasks, i)}</TableTd>
      {/* @ts-ignore: Type 'SerializedStyles' is not assignable to type 'string'. */}
      <TableTd className={[cell, td]}>
        {formatPrice(tier.pricePerTask, currency)}
      </TableTd>
    </TableRow>
  ));
};

export const MeteredTiersTable = ({ tiers }: MeteredTiersTableProps) => {
  const currency = useContext(CurrencyContext);
  const { useQuery } = useApolloInjection();
  const { currentPlanTiers } = useCurrentPlanTiers({ skip: !!tiers, useQuery });
  const planTiers = tiers ?? currentPlanTiers ?? [];

  const rows = formatTiers(planTiers, currency);

  return planTiers.length > 0 ? (
    <Table kind="standard">
      <TableHead>
        <TableRow>
          {/* @ts-ignore: Type 'SerializedStyles' is not assignable to type 'string'. */}
          <TableTh className={cell}>Tasks</TableTh>
          {/* @ts-ignore: Type 'SerializedStyles' is not assignable to type 'string'. */}
          <TableTh className={cell}>Price Per Task</TableTh>
        </TableRow>
      </TableHead>
      <TableBody>{rows}</TableBody>
    </Table>
  ) : null;
};
